import { Form, InputNumber } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateLaborTab } from '../../../../../contextRedux/PMContract/PmContractModel';
import { RootState } from '../../../../../store';
import DevicesTable from './DevicesTable/DevicesTable';
import './LaborTab.css';
import LaborTable from './LaborTable/LaborTable';

const LaborTab: React.FC<any> = ({}) => {
  const dispatch = useDispatch();
  const pmContract = useSelector((state: RootState) => state?.models?.pmContract);

  const handleLaborPriceChange = (value: number | null) => {
    if (value !== null) {
      dispatch(updateLaborTab({ field: 'laborPriceOnHour', value: value ?? 300 }));
    }
  };

  return (
    <div>
       <div className='estimate-container'>
        <h1>Costuri estimate</h1>
        <Form.Item label='Pret manopera per ora' name='laborPriceOnHour' className='formItem'>
          <InputNumber
            placeholder='Ex: 300'
            value={pmContract.laborTab.laborPriceOnHour ?? 300}
            onChange={handleLaborPriceChange}
          />
        </Form.Item>
      </div>
      <DevicesTable />
      <div style={{ height: 25 }}></div>
      <LaborTable key={'id'} />
      <div style={{ height: 25 }}></div>
    </div>
  );
};

export default LaborTab;
